<template>
  <div>
    <!--      <search-form @setSearchCondition="setSearchCondition" @clearSearch="clearSearch"></search-form>-->
    <!--      操作按钮-->
    <div class="table-operator">
      <a-button
        type="primary"
        v-action:saveFollow
        icon="plus"
        @click="handleAdd"
        style="margin-right: 10px"
      >新增</a-button
      >
      <a-popconfirm title="确定要批量删除吗?" @confirm="batchDel">
        <a-button v-action:deleteFollow icon="delete">批量删除</a-button>
      </a-popconfirm>
    </div>
    <!--表格-->
    <zm-table
      :columns="table.columns"
      :rowKey="(record) => record.id"
      :dataSource="table.data"
      :pagination="pagination"
      :loading="table.loading"
      @change="handleTableChange"
      :rowSelection="rowSelection"
      :scroll="{ x: 1180 }"
    >
      <template v-slot:info="{ text, record }">
        <span class="prewrap">{{ record.info }}</span>
      </template>
      <template v-slot:remark="{ text, record }">
        <span class="prewrap">{{ record.remark }}</span>
      </template>
      <template v-slot:actions="{ text, record }">
        <a href="javascript:;" @click="() => handleView(record)">查看</a>
        <a-divider type="vertical" />
        <a href="javascript:;" v-action:saveFollow @click="() => handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-popconfirm v-if="table.data.length" title="确定要删除吗?" @confirm="() => onDelete(record)">
          <a v-action:deleteFollow href="javascript:;">删除</a>
        </a-popconfirm>
      </template>
    </zm-table>
    <!--各种弹出组件-->
    <edit-modal ref="editModal" @refreshTable="initTableData"></edit-modal>
    <detail-modal ref="detailModal" @refreshTable="initTableData"></detail-modal>
  </div>
</template>

<script>
import { getFollowsList, deleteFollows } from '@/api/follows'
import editModal from './modules/editModal'
import detailModal from './modules/detailModal'
import searchForm from './modules/searchForm'
import baseCard from '@/CrComponents/Card/Card'
import moment from 'moment'

export default {
  name: 'FollowsList',
  mounted () {
    this.searchModel = { ...this.pagination }
    this.initTableData()
  },
  computed: {
    marketModel () {
      return this.$store.state.market.marketModel
    }
  },
  watch: {
    marketModel (newVal) {
      if (newVal.id) {
        this.initTableData()
      }
    }
  },
  components: {
    editModal,
    searchForm,
    detailModal,
    baseCard
  },
  data () {
    return {
      proprietorModel: {},
      model: {},
      // card相关属性设置
      cardOption: {},
      // 搜索form中的参数
      searchFormModel: {},
      // 所有搜索条件 包括分页，搜素框，表格上筛选条件
      searchModel: {},
      // 表格中的查询条件
      searchTableModel: {},
      // 高级搜索 展开/关闭
      searchInput: null,
      searchText: '',
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectedRows = selectedRows
        }
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      table: {
        data: [],
        columns: [
          {
            title: '进展情况',
            dataIndex: 'info',
            width: 300,
            scopedSlots: {
              customRender: 'info'
            }
          },
          {
            title: '需要协调信息',
            dataIndex: 'remark',
            // width: 300,
            scopedSlots: {
              customRender: 'remark'
            }
          },
          {
            title: '联系人',
            dataIndex: 'contactName',
            width: 100
          },
          {
            title: '跟踪人',
            dataIndex: 'trackerName',
            width: 100
          },
          {
            title: '跟踪时间',
            dataIndex: 'traceTime',
            customRender: (text) => {
              return text ? moment(text).format('YYYY-MM-DD') : ''
            },
            width: 120
          },
          {
            title: '跟进状态',
            dataIndex: 'statusName',
            width: 120
          },
          {
            title: '操作',
            width: 140,
            align: 'right',
            fixed: 'right',
            scopedSlots: {
              customRender: 'actions'
            }
          }
        ],
        searchCondition: {},
        loading: false,
        filteredInfo: null,
        sortedInfo: null
      }
    }
  },
  methods: {
    setProprietorModel (model) {
      this.proprietorModel = model
    },
    // 搜索
    setSearchCondition (searchFormModel) {
      this.searchFormModel = searchFormModel
      this.searchModel = { ...this.pagination, ...this.searchTableModel, ...searchFormModel }
      this.initTableData()
    },
    // 重置
    clearSearch (searchFormModel) {
      this.pagination.pageNum = 1
      this.searchModel = { ...this.pagination, ...this.searchTableModel }
      this.table.filteredInfo = null
      this.table.sortedInfo = null
      delete this.searchModel.sortField
      delete this.searchModel.sortOrder
      this.initTableData()
    },
    // 表格中的搜索
    handleSearch (selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    // 表格中的重置
    handleReset (clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    // 初始化表格数据
    initTableData () {
      this.table.loading = true
      this.searchModel.marketId = this.marketModel.id
      getFollowsList(this.searchModel).then((res) => {
        if (res.status === 0) {
          this.table.loading = false
          this.table.data = res.data.list
          this.pagination.total = res.data.total
        } else {
          this.$message.error('获取数据失败！')
        }
      })
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.table.filteredInfo = filters
      this.table.sortedInfo = sorter
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.searchModel = {
        ...this.searchFormModel,
        ...this.pagination,
        ...this.searchTableModel,
        sortField: sorter.field,
        sortOrder: sorter.order
      }
      this.initTableData()
    },
    // 删除操作
    onDelete (model) {
      deleteFollows(model.id).then((res) => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.initTableData()
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 查看详情
    handleView (model) {
      this.$refs.detailModal.setTitle('查看跟进信息')
      this.$refs.detailModal.setType(this.$sysInfo.MODAL_VIEW)
      this.$refs.detailModal.setModel(model) // 先设置类型，再打开
      this.$refs.detailModal.open(true)
    },
    // 编辑
    handleEdit (model) {
      this.$refs.editModal.setTitle('编辑跟进信息')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_MODIFY)
      this.$refs.editModal.setModel(model) // 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    // 新增
    handleAdd () {
      this.$refs.editModal.setTitle('新增跟进信息')
      // this.$refs.editModal.setModel(this.model)
      this.$refs.editModal.setType(this.$sysInfo.MODAL_ADD) // 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    // 批量删除
    batchDel () {
      const searchModel = this.selectedRows
      if (!searchModel || searchModel.length === 0) {
        this.$message.error('请至少选择一行数据进行删除！')
        return
      }
      let params = ''
      searchModel.map((item) => {
        params += item.id + ','
      })
      params = params.substring(0, params.length - 1)
      deleteFollows(params).then((res) => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.initTableData()
        } else {
          this.$message.error(res.info.message)
        }
      })
    }
  }
}
</script>

<style scoped>
.prewrap {
  white-space: pre-wrap;
}
</style>
